import { useEffect, useMemo, useState } from 'react';
import { handleFilterChange } from '../../helpers/helpers';
import { debounce } from 'lodash';

export const SearchInputFilter = ({
  searchParams,
  setSearchParams,
  param,
  placeholder,
  onChange,
  value,
  disabled
}: {
  searchParams?: URLSearchParams;
  setSearchParams?: any;
  param?: string;
  placeholder?: string;
  onChange?: any;
  value?: string;
  disabled?: boolean;
}) => {
  const [inputValue, setInputValue] = useState(
    value || (searchParams && param && searchParams.get(param)) || ''
  );

  useEffect(() => {
    setInputValue(
      value || (searchParams && param && searchParams.get(param)) || ''
    );
  }, [searchParams, param, value]);

  const updateSearchParams = (value: string) => {
    if (!setSearchParams || !param) return;

    if (value.trim() === '') {
      const newParams = new URLSearchParams(searchParams);

      newParams.delete(param);

      setSearchParams(newParams);
    } else {
      handleFilterChange(param, value, setSearchParams);
    }
  };

  const debouncedResults = useMemo(() => {
    return debounce((value: string) => {
      updateSearchParams(value);
    }, 500);
  }, [searchParams]);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, [debouncedResults]);

  return (
    <div className='search-box me-2 mb-2 d-inline-block col-12'>
      <input
        value={inputValue}
        disabled={disabled}
        onChange={(e) => {
          const value = e.target.value;

          setInputValue(value);

          if (onChange) {
            onChange(e);
          } else {
            debouncedResults(value);
          }
        }}
        type='text'
        className='form-control search'
        placeholder={placeholder || 'Search'}
      />

      <i className='bx bx-search-alt search-icon'></i>
    </div>
  );
};
